import React from "react";
import { Box } from "@mui/material";

export const Forbidden = () => <Box>Forbidden</Box>;
